import React, { useState, useEffect, Fragment } from 'react';
import { Row, Modal, ModalBody, Button, Card, CardBody } from 'reactstrap';
import styled from "styled-components";
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { RotateSpinner } from 'react-spinners-kit';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import moment from 'moment';
import {
    gAPI_BotResponseHistory
} from '../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import HeroCardResponse from './HeroCardResponse';
import ExampleResponse from './ExampleResponse';
import MessageResponse from './MessageResponse';
import LinkResponse from './LinkResponse';
import VideoResponse from './VideoResponse';
import ImageCarouselResponse from './ImageCarouselResponse';

const ModelDiv = styled.div`
    border-bottom: 1px solid #d7d7d7;
    padding: 0rem 0rem 1rem 0rem;
    border-top-left-radius: 0.3rem;
    border-top-right-radius: 0.3rem;
    .close-model{
        padding: 1rem 1rem;
        margin: -1rem -1rem -1rem auto;
        background-color: transparent;
        border: 0;
        float: right;
        font-size: 1.5rem;
        font-weight: 700;
        line-height: 1;
        color: #000;
        text-shadow: 0 1px 0 #fff;
        opacity: .5;
    }`;

const GenerateResponseBlock = ({ elem, reloadBotResponse, historyUpdator }) => {
    switch (elem.response.type) {
        case 'example':
            return (
                <ExampleResponse
                    child={1}
                    ishistory={true}
                    elem={{ ...elem }}
                    viewResponse={true}
                    reloadBotResponse={reloadBotResponse}
                    historyUpdator={historyUpdator}
                />
            );

        case 'messages':
            return (
                <MessageResponse
                    child={1}
                    ishistory={true}
                    elem={{ ...elem }}
                    viewResponse={true}
                    reloadBotResponse={reloadBotResponse}
                    historyUpdator={historyUpdator}
                />);

        case 'messages-link':
            return (
                <Fragment>
                    <LinkResponse
                        child={1}
                        ishistory={true}
                        elem={{ ...elem }}
                        viewResponse={true}
                        reloadBotResponse={reloadBotResponse}
                        historyUpdator={historyUpdator}
                    ></LinkResponse>
                </Fragment>
            );

        case 'messages-image-carousel':
            return (
                <Fragment>
                    <ImageCarouselResponse
                        child={1}
                        ishistory={true}
                        elem={{ ...elem }}
                        viewResponse={true}
                        reloadBotResponse={reloadBotResponse}
                        historyUpdator={historyUpdator}
                    />
                </Fragment>
            );
        case 'messages-video':
            return (
                <Fragment>
                    <VideoResponse
                        child={1}
                        ishistory={true}
                        elem={{ ...elem }}
                        viewResponse={true}
                        reloadBotResponse={reloadBotResponse}
                        historyUpdator={historyUpdator}
                    />
                </Fragment>
            );
        case 'herocard':
            return (
                <Fragment>
                    <HeroCardResponse
                        child={1}
                        ishistory={true}
                        elem={{ ...elem }}
                        viewResponse={true}
                        reloadBotResponse={reloadBotResponse}
                        historyUpdator={historyUpdator}
                    />
                </Fragment>
            );
        case '':
            return null;
        default:
            break;
    }
}
function ResponseLogs({ propertyId, code, reloadBotResponse, visible, toggle, selectedLang, hintQuestion, historyUpdator }) {
    const [isLoading, setIsLoading] = useState(true);
    const [historyData, setHistoryData] = useState([]);
    const [isHistory, setIsHistory] = useState(false);

    useEffect(() => {
        handleChangeLog();
    }, [code]);

    const handleChangeLog = () => {
        AxiosAPI({
            method: 'get',
            url: `${gAPI_BotResponseHistory}?code=${code}&property_id=${propertyId
                }&group_id=${getGroupID()
                }&lang=${selectedLang === 'en' ? 'en-US' : selectedLang}&channel=WebsiteDirectLine`,
        }).then((res) => {
            setIsHistory(true);
            setHistoryData(res.data);
            setTimeout(() => {
                setIsLoading(false);
            }, 500);
        }).catch((err) => {
            console.log(err);
        });
    };

    return (
        <Fragment>
            <Row>
                <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
                    <Row>
                        <Colxx xs="12" sm="3" className="mb-1">
                            <Modal isOpen={visible} toggle={toggle} style={{ maxWidth: '1000px' }}>
                                <ModalBody>
                                    <ModelDiv>
                                        <Row>
                                            <Colxx xxs="6">
                                                <h5>Change Log with Previous Version of the Message</h5>
                                            </Colxx>
                                            <Colxx xxs="6">
                                                <div className='float-right mt-4'>
                                                    <button onClick={() => toggle()} type='button' className='close close-model'>
                                                        <span>x</span>
                                                    </button>
                                                </div>
                                            </Colxx>
                                        </Row>
                                    </ModelDiv>
                                    <div className='d-flex' style={{ flexWrap: "nowrap", flexDirection: "column" }}>
                                        {/* {!isHistory ? 
                                            <div className='text-right mb-2 mt-2'>
                                                <Button
                                                    color="secondary"
                                                    className="add-button"
                                                    size="xs"
                                                    style={{ width: "max-content" }}
                                                    onClick={handleChangeLog}
                                                >
                                                    Change Log
                                                </Button>
                                            </div> :*/}
                                        {isLoading ?
                                            <Row>
                                                <Colxx xxs="5" className="mb-2"></Colxx>
                                                <Colxx xxs="2" className="mb-2">
                                                    <RotateSpinner size={60} color="#4556AC" loading={isLoading} />
                                                </Colxx>
                                                <Colxx xxs="5" className="mb-2"></Colxx>
                                            </Row> :
                                            historyData.length > 0 ?
                                                <div style={{ overflowY: "scroll", maxHeight: "40rem", display: "flex" }}>
                                                    <div className='mt-2' style={{ width: "98%" }}>
                                                        {historyData.map((history, i) => (
                                                            <Card key={i}>
                                                                <CardBody className="mt-0" style={{ marginLeft: "-15px" }}>
                                                                    <Row>
                                                                        <Colxx xxs="12" xs="3" className="">
                                                                            <h2>{hintQuestion}</h2>

                                                                            Version On:<br />
                                                                            {/* {moment(history.updatedDate).format(
                                                                                'DD-MM-YYYY h:mm a'
                                                                            )} */}
                                                                            {moment(history.updatedDate).format('MMMM Do, YYYY h:mm a')}
                                                                            <br /><br />
                                                                            {history.historyUpdator !== undefined &&
                                                                                <Fragment>
                                                                                    Updated By:<br />
                                                                                    {history.historyUpdator}<br /><br />
                                                                                </Fragment>
                                                                            }
                                                                            {history.action !== undefined &&
                                                                                <Fragment>
                                                                                    Action:<br />
                                                                                    <span style={{ color: `${history.action === "Deleted" ? "red" : ""}` }}>{history.action}</span>
                                                                                </Fragment>
                                                                            }
                                                                        </Colxx>
                                                                        <Colxx xxs="12" xs="9">
                                                                            <GenerateResponseBlock
                                                                                key={i}
                                                                                elem={history}
                                                                                reloadBotResponse={reloadBotResponse}
                                                                                historyUpdator={historyUpdator}
                                                                            ></GenerateResponseBlock>
                                                                        </Colxx>
                                                                    </Row>
                                                                </CardBody>
                                                            </Card>
                                                        ))
                                                        }
                                                    </div>
                                                </div> :
                                                <div className='text-center pt-4'>
                                                    <h2>No History Found</h2>
                                                </div>
                                        }
                                        {/* } */}
                                    </div>
                                </ModalBody>
                            </Modal>
                        </Colxx>
                    </Row>
                </Colxx>
            </Row>
        </Fragment>
    );
}
const mapStateToProps = ({ settings }) => {
    const { propertyId, locale } = settings;
    return {
        propertyId, locale
    };
};

export default injectIntl(connect(mapStateToProps, {})(ResponseLogs));